export interface ReferencePackImagePreview {
  id: string;
  imageUrl: string;
  thumbnailUrl?: string | null;
}

export function getReferencePackThumbnailUrl(image: ReferencePackImagePreview) {
  return image.thumbnailUrl || `/api/products/reference-packs/assets/${image.id}/thumbnail`;
}
